import { useEffect, useState } from 'react';
import { Layout } from '../../../components';
import { Tevent, initialEvent } from '../../../type/event';
import { useNavigate, useParams } from 'react-router-dom';
import { getDataDetail } from '../../../service/eventService';
import { QrScanner } from '@yudiel/react-qr-scanner';

const ScanQr = () => {
	const navigate = useNavigate();

	return (
		<Layout
			title="Scan QR Kehadiran"
			showNavBar={true}
			showNavigation={false}
		>
			<div className="flex flex-col gap-4 my-14 text-center">
				<QrScanner
					onDecode={(result) => navigate(`${result}`)}
					onError={(error) => console.log(error?.message)}
				/>
			</div>
		</Layout>
	);
};

export default ScanQr;
